module.exports = __webpack_public_path__ + "img/games-3.9994568b.webp";